import React from 'react';
import { ControlledCommande } from 'types/commande/commande.def';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { formatCommandStatus } from 'helpers/commande/formatCommand';
import { UserName } from '../../../../../types/user/user.def';
import { useToCommandePages } from 'hooks/useToCommandePages';

export interface TableMyResultControlProps {
  eleve: UserName;
  commande: ControlledCommande;
  onChange: (e: any) => void;
}

export const MobileTabLineControl = ({
  eleve,
  commande,
  onChange
}: TableMyResultControlProps) => {
  const [toCommandeUpdatePage] = useToCommandePages();
  const handleChange = (id, value) => {
    const e = {
      target: {
        value: id,
        checked: value
      }
    };
    onChange(e);
  };
  return (
    <FeatureContainer padding="mobileTab">
      <MobileTabLineBox
        texts={[
          { text: eleve.firstname, style: 'bold' },
          { text: eleve.lastname, style: 'bold' },
          { text: 'N° ' + commande.numerocommande },
          { text: commande.client.prenom + ' ' + commande.client.nom },
          {
            text: `${commande.totalttc} € (+ ${
              commande.fraislivraison
            } € port + ${
              commande.customerContributedToTheOng ? '1€' : '0€'
            } ong)`
          },
          { text: 'Méthode de paiement : ' + commande.methodepaiement }
        ]}
      />
      <ButtonWithText
        variant="mobileTab"
        onClick={() => toCommandeUpdatePage(String(commande.id))}
        icon={'Edit'}
        content="Modifier"
      />
      <MobileTabLineBox
        title="Statut"
        texts={[{ text: formatCommandStatus(commande.status), style: 'bold' }]}
      />
      <MobileTabLineBox
        title="Total TTC"
        texts={[
          {
            text: commande.prixTotal + ' €',
            style: 'bold'
          }
        ]}
      />
      <span>Statut de la commande :</span>
      <ButtonWithText
        onClick={() => handleChange(commande.id, !commande.controlled)}
        variant={commande.controlled ? 'primaryGreen' : 'danger'}
        iconColor={commande.controlled ? '#000000' : '#D12C3F'}
        icon={commande.controlled ? 'Tick' : 'Close'}
        content={
          commande.controlled ? 'Commande validée' : 'Commande non-validée'
        }
      />
      <span role="img" aria-label="info">
        ❓ Appuyer sur le bouton au dessus pour changer le statut de la
        commande.
      </span>
    </FeatureContainer>
  );
};
